import { createContext as e, useContext as r, useMemo as t, createElement as n } from "react";
import * as o from "ua-parser-js";
var i = e({});

var u = function u(e) {
  var r = e.children,
      u = e.userAgent,
      a = t(function () {
    var e = new o();
    return e.setUA(u), {
      os: e.getOS(),
      browser: e.getBrowser(),
      cpu: e.getCPU(),
      device: e.getDevice(),
      engine: e.getEngine()
    };
  }, [u]);
  return n(i.Provider, {
    value: a
  }, r);
};

export default function () {
  return r(i);
}
export { u as UserAgentProvider };